import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UploadHistoryProvider, useUploadHistoryContext } from '../../../../../contexts/UploadHistoryContext';
import { Button } from '../../../../../components/ui/button';
import { CardContent } from '../../../../../components/ui/card';
import ConfirmDialog from '../../../../../components/ConfirmDialog';
import CollapsibleCard from '../../../../../components/CollapsibleCard';
import RejectAddFields from './RejectAddFields';
import MappedFields from '../../step3/MappedFields';
import { rejectReview, runEtlProcess, viewUploadLog } from '../../../../../store/uploads/actions';
import { useNavigate, useParams } from 'react-router-dom';
import { setErrors } from '../../../../../store/vendors/actions';
import ReviewFormData from '../../step2/ReviewFormData';
import { format } from 'date-fns';
import ViewAdditionalFields from '../../views/ViewAdditionalFields';


const Content = () => {
    const { key } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { action, setAction } = useUploadHistoryContext();
    const [ rejectRemarks, setRejectRemarks ] = useState("");
    const { reviewData, viewLogData, errors } = useSelector((state) => state.Uploads);
    const closeModal = (modalType) => {
        setAction(prev => ({ ...prev, open: false, modal: modalType }));
    };
    const approveReviewRequest = () => {
        closeModal("approve");
        dispatch(runEtlProcess({
            id: viewLogData.id || viewLogData._id,
            navigate
        }));
    };
    const rejectReviewRequest = () => {
        if(!rejectRemarks.trim()){
            dispatch(setErrors({...errors, remarks: "Please give some remarks for this rejection."}))
        } else {
            closeModal("reject");
            dispatch(rejectReview({
                id: viewLogData.id || viewLogData._id, 
                remarks: rejectRemarks,
                navigate,
            }));
        }
    };

    const reviewFormData = [
        { label: 'Source Type:', value: viewLogData.sourceType },
        { label: 'Master Project:', value: viewLogData.masterProject },
        { label: 'Project:', value: viewLogData.project },
        { 
            label: viewLogData.sourceType === "Channel Partner" ? 'Channel Partner:': 'Vendor Name:',
            value: viewLogData.sourceType === "Channel Partner" ? viewLogData.channelPartner : viewLogData.vendor
        },
        { label: 'SPOC:', value: viewLogData.spoc },
        { label: 'Uploaded By:', value: viewLogData.uploadedBy },
        { label: 'Data Category:', value: viewLogData.dataCategory },
        { label: 'Lead Source:', value: viewLogData.leadSource },
        { label: 'Extracted On:', value: viewLogData.extractedOn ? format(viewLogData.extractedOn, 'MMMM do yyyy') : "" },
        { label: 'Reason of Procurement:', value: viewLogData.procReason }
    ];

    const passData = {
        pending: viewLogData.pending,
        file: viewLogData.file
    }

    useEffect(() => {
        if(key && !viewLogData._id){
            dispatch(viewUploadLog({key: key}))
        }
    }, [dispatch, key, viewLogData._id]);

    return (
        <>
            <CollapsibleCard 
                title="Review Upload Details"
                className="bg-white bg-opacity-100 mt-5"
                showCollapseButton={false}
                showBackButton={true}
                handleBack={() => navigate(-1)}
            >
                <CardContent>
                    <h5 className="font-semibold text-md text-primary-300 mb-5">
                        Please review the file details and additional fields below
                    </h5>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                        <div>
                            <ReviewFormData reviewFormData={reviewFormData} data={passData} />
                        </div>

                        <div className="grid grid-cols-1 gap-4 items-stretch">
                            <div className="col">
                                <MappedFields hideFieldSelection={true} hideNavigationButtons={true} />
                            </div>
                            <div className="col">
                                {/* <AdditionalFields hideFieldSelection={false} hideNavigationButtons={true} /> */}
                                <ViewAdditionalFields />
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-end mt-3">
                        <Button variant="outline" className="mr-2" onClick={e => setAction({id: reviewData._id, open: true, modal: "reject"})}>
                            Reject
                        </Button>
                        <Button className="" onClick={e => setAction({id: reviewData._id, open: true, modal: "approve"})}>
                            Accept
                        </Button>
                    </div>

                </CardContent>
            </CollapsibleCard>
            <ConfirmDialog
                open={action.open && action.modal === "approve"}
                titleText="Approve Additional Fields"
                descriptionText="Are you sure you want to add the fields to the database?"
                actionText="Approve"
                confirmAction={approveReviewRequest}
                handleClose={() => closeModal("approve")}
            />
            <RejectAddFields
                open={action.open && action.modal === "reject"}
                confirmAction={rejectReviewRequest}
                setRejectRemarks={setRejectRemarks}
                rejectRemarks={rejectRemarks}
                handleClose={() => closeModal("reject")}
            />
        </>
    );
};

const ReviewUpload = () => (
    <UploadHistoryProvider>
        <Content />
    </UploadHistoryProvider>
);

export default ReviewUpload;
